import { render, staticRenderFns } from "./Single_product_page.vue?vue&type=template&id=7b3d3ff0&"
import script from "./Single_product_page.vue?vue&type=script&lang=js&"
export * from "./Single_product_page.vue?vue&type=script&lang=js&"
import style0 from "./Single_product_page.vue?vue&type=style&index=0&id=7b3d3ff0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports